module.exports = __webpack_public_path__ + "4f0533233b03999e08028798f274112d.MP3";